import { Controller } from '@hotwired/stimulus';
import { MDCRipple } from '@material/ripple';

export default class extends Controller {
  static targets = ['primaryAction'];

  initialize() {
    this.ripples = [];
  }

  primaryActionTargetConnected(element) {
    this.ripples.concat(new MDCRipple(element));
  }

  disconnect() {
    this.ripples.forEach((ripple) => {
      ripple.destroy();
    });
  }
}
